import { render, staticRenderFns } from "./CorridorAwareness.vue?vue&type=template&id=f2af0c4a&scoped=true&"
import script from "./CorridorAwareness.vue?vue&type=script&lang=js&"
export * from "./CorridorAwareness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af0c4a",
  null
  
)

export default component.exports